/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AttachmentSourceType {
    Notes = 1,
    Location = 2,
    Resource = 3,
    SolutionMember = 4,
}
